<template>
  <div>
    <div class="grid grid-cols-4">
      <div class=" ">
        <fieldset>
          <legend>
            <h2 class="text-base font-semibold leading-6 text-gray-900">
              <slot name="title">Evolution by recipient Regions</slot><br />
            </h2>
            <p class="text-xs font-light">
              <slot name="subtitle"
                >Select
                <strong
                  class="text-bold"
                  :class="
                    animateMessage
                      ? ['blink text-Secondary-600 font-extrabold']
                      : ''
                  "
                  >up to 6 regions</strong
                >
                (sorted by value)</slot
              >
            </p>
          </legend>
          <div class="relative mt-2 flex items-center">
            <input
              type="text"
              name="search"
              id="search"
              ref="searchInput"
              v-model="searchQuery"
              placeholder="Search"
              class="block w-full rounded-md border-0 py-1.5 pr-14 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-Primary-600 sm:text-sm sm:leading-6"
            />
          </div>

          <TransitionGroup
            tag="ul"
            class="geo-list-container mt-4 divide-y divide-gray-200 border-b border-t border-gray-200 h-[400px] overflow-y-scroll pr-4"
            name="lista"
          >
            <li
              v-for="georegion in allRecipientsListSortedAndFilteredBySearch"
              :key="georegion.recipient_code"
              class="flex items-start py-4"
              @click="($event) => onGeoregionContainerClick($event)"
            >
              <div class="min-w-0 flex-1 text-sm leading-6">
                <label
                  :for="`georegion-${georegion.recipient_code}`"
                  class="select-none font-medium text-gray-900"
                  >{{ georegion.name }}</label
                >
              </div>
              <div class="ml-3 flex h-6 items-center">
                <input
                  :id="`georegion-${georegion.recipient_code}`"
                  :name="`georegion-${georegion.recipient_code}`"
                  type="checkbox"
                  @click.stop=""
                  :checked="georegion.checked"
                  v-model="georegion.checked"
                  @change="onGeoregionChange(georegion)"
                  :class="{
                    'pointer-events-none': getInteractionClass(georegion),
                  }"
                  class="h-4 w-4 rounded border-gray-300 text-Primary-600 focus:ring-Primary-600"
                />
              </div>
            </li>
          </TransitionGroup>
        </fieldset>
      </div>
      <div class="col-span-3" ref="linechartcontainer">
        <ClientOnly>
          <chartsLineCharts
            v-if="dataByYear"
            :chartdata="dataByYear"
            :yyySeries="yyySeries"
            :availableWidth="linechartAvailableWidth"
            :fullDomain="availableRecipientsObjects"
            :formatTools="$formater.salaryFormater"
          >
          </chartsLineCharts>
        </ClientOnly>
      </div>
    </div>
  </div>
</template>

<script setup>
import { queries } from "@/assets/queries.js";
import { httpConfig,baseYearRange } from "@/assets/baseTypes.js";
import allRecipients from "@/assets/recipients.json";
import { geo } from "@observablehq/plot";
const { $formater } = useNuxtApp();
import * as d3 from "d3";
const linechartcontainer = ref(null);

const { width: linechartAvailableWidth } = useElementSize(linechartcontainer);
//** prepare data for stacked */
const config = useRuntimeConfig();
const props = defineProps({
  availableRecipientsObjects: {
    type: Array,
    default: () => {
      return [
        { recipient_code: "798", name: "Asia" },
        { recipient_code: "298", name: "Africa" },
      ];
    },
  },
  maxLines: {
    type: Number,
    default: 5,
  },
  labelField: {
    type: String,
    default: "name",
  },
  valueField: {
    type: String,
    default: "TOTAL",
  },
  idField: {
    type: String,
    default: "recipient_code",
  },
});


const searchQuery = ref("");
/** search input */
const searchInput = ref(null);
const allRecipientsListSorted = ref([]);

const allRecipientsListSortedAndFilteredBySearch = ref([]);
const selectedRecipientIds = ref([]);

let allRecipientsListObj = ref([]);

watch(
  () => props.availableRecipientsObjects,
  (newValue) => {
    allRecipientsListObj = ref(initializeRecipientsList(newValue));
    sortAndInitList();
  },
  {
    deep: true,
    immediate: true,
  }
);

function initializeRecipientsList(recipients) {
  return recipients
    .filter(
      (d) =>
        d[props.labelField] != "" &&
        d[props.labelField] != "Bilateral, unspecified" &&
        d[props.labelField] != undefined
    )
    .map((r, i) => {
      return {
        recipient_code: r[props.idField] + "",
        name: r[props.labelField],
        checked: i < 5 ? true : false,
      };
    });
}


watch(
  [allRecipientsListSorted, searchQuery],
  ([newRecipientsList, newSearchQuery]) => {
    if (newSearchQuery.length < 2) {
      allRecipientsListSortedAndFilteredBySearch.value =
        allRecipientsListObj.value;
    } else {
      allRecipientsListSortedAndFilteredBySearch.value =
        newRecipientsList.filter((r) =>
          r.name.toLowerCase().includes(newSearchQuery.toLowerCase())
        );
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const yyySeries = computed(() => {
  return d3.range(baseYearRange[0], baseYearRange[1] + 1);
});

const { data: dataByYear, refresh: refreshDataByYear } = await useAsyncData(
  "dataByYear3" + JSON.stringify(selectedRecipientIds.value),
  () => {
    const configByYear2 = httpConfig(
      JSON.stringify(
        queries.getTotalByYearCategoryManyRecipients(selectedRecipientIds.value)
      )
    );
    return $fetch(config.public.apiURL, configByYear2);
  },
  {
    transform: (data) => {
      /*
        { "documents": [ { "_id": [ "425", 2014 ], "TOTAL": 2.160013 }, { "_id": [ "425", 2015 ], "TOTAL": 3.023398 }, { "_id": [ "625", 2020 ], "TOTAL": 59.490553 },

        // I need to transform this array into an object like:
        [
            { // for each id:
                "_id": "425"
                serie: [
                    year: "2014", value : 2.160013,
                    year: "2015", value : 3.023398,                    
                    year: "2016", value : 0,
                    ...
                ]                
            }
        ]
        */
      const allRegionsByYear = data.documents.reduce((acc, cur) => {
        const recipient_code = cur._id[0];
        const year = cur._id[1];
        const value = cur.TOTAL;
        const existingRegion = acc.find((r) => r._id == recipient_code);
        if (existingRegion) {
          existingRegion.serie.push({ yy: year, vv: value });
        } else {
          acc.push({
            _id: recipient_code,
            serie: [{ yy: year, vv: value }],
          });
        }
        return acc;
      }, []);
      // iterate and add a name field using recipients.json matching with _id
      // also go through each serie and add missing years with value 0

      allRegionsByYear.forEach((region) => {
        const recipient = allRecipients.find(
          (r) => r.recipient_code == region._id
        );
        region.name = recipient.name;
        const years = region.serie.map((s) => s.yy);
        const missingYears = yyySeries.value.filter(
          (y) => !years.includes(parseInt(y))
        );
        missingYears.forEach((y) => {
          region.serie.push({ yy: y, vv: 0 });
        });
        // sort by yy
        region.serie.sort((a, b) => a.yy - b.yy);
      });
      return allRegionsByYear;
    },
  }
);

// search section

const onGeoregionChange = (georegion) => {
  if (georegion.checked) searchQuery.value = "";
  sortAndInitList();
  refreshDataByYear();
};

function sortAndInitList() {
  allRecipientsListSorted.value = allRecipientsListObj.value.sort((a, b) => {
    if (a.checked && !b.checked) return -1;
    if (!a.checked && b.checked) return 1;
    return 0;
  });

  selectedRecipientIds.value = allRecipientsListSorted.value
    .filter((r) => r.checked)
    .map((r) => r.recipient_code);
}

const getInteractionClass = (georegion) => {
  const checkedCount = selectedRecipientIds.value.length;
  if (checkedCount < 2 && georegion.checked) return true;
  if (checkedCount > 5 && !georegion.checked) return true;
  return false;
};

const animateMessage = ref(false);
const onGeoregionContainerClick = ($event) => {
  const checkedCount = selectedRecipientIds.value.length;
  if (checkedCount > 5) {
    animateMessage.value = true;
    setTimeout(() => {
      animateMessage.value = false;
    }, 2000);
  }
};
</script>

<style lang="css" scoped>
.blink {
  animation: blink-animation 0.5s steps(5, start) infinite;
  -webkit-animation: blink-animation 0.5s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>

<style lang="scss">
ul.geo-list-container {
  scrollbar-width: thin;
  scrollbar-color: #3e4bad;
}

ul.geo-list-container::-webkit-scrollbar {
  width: 8px;
}

ul.geo-list-container::-webkit-scrollbar-thumb {
  background: #3e4bad;
  border-radius: 12px;
}

ul.geo-list-container::-moz-scrollbar-thumb {
  background: #3e4bad;
  border-radius: 12px;
}

ul.geo-list-container::-webkit-scrollbar-track {
  background-color: #fff;
  border: 0px solid #ccc;
  border-radius: 12px;
}

ul.geo-list-container::-moz-scrollbar-track {
  background-color: #fff;
  border: 0px solid #ccc;
  border-radius: 12px;
}

ul.geo-list-container::-webkit-scrollbar-button {
  background-color: #3e4bad;
  border-radius: 12px;
}

ul.geo-list-container::-moz-scrollbar-button {
  background-color: #3e4bad;
  border-radius: 12px;
}
</style>

<style>
.lista-move {
  transition: all 0.3s;
} /* apply transition to moving elements */
.lista-enter-active,
.lista-leave-active {
  transition: all 0.1s;
}

.lista-enter-from,
.lista-leave-to {
  opacity: 0;
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.lista-leave-active {
  position: absolute;
}
</style>
